import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthInterceptorService } from './interceptor/auth-interceptor.service';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { MyhttpinterceptorInterceptor } from './interceptor/myhttpinterceptor.interceptor';
import { ToastModule } from 'primeng/toast';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/compiler';
import { QCommonModule } from './modules/q-common/q-common.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    PagenotfoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FeatherModule.pick(allIcons),
    MatSnackBarModule,
    NgxSpinnerModule,
    ToastModule,
    BrowserAnimationsModule,
    QCommonModule
  ],
  providers: [NgxSpinnerService,
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyhttpinterceptorInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB', multi:true},
    {
      provide:LocationStrategy,useClass: HashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
